module.exports = __webpack_public_path__ + "static/img/yeedai.46f331c.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/yeedai.gif
// module id = Tl5N
// module chunks = 1